<template>
  <div class="page-container">
    <AppSidebar />

    <div class="main-content">
      <div class="youth-page">
        <section class="hero-card">
          <div class="hero-copy">
            <p class="eyebrow">健康阅读守护</p>
            <h1>青少年保护</h1>
            <p class="hero-desc">开启后，当前设备每天最多访问本站 2 小时。时间用完后，页面会进入保护锁定状态，提醒用户休息并关闭网站。</p>
            <div class="hero-actions">
              <button v-if="!status.enabled" class="primary-btn" @click="focusPassword">开启青少年保护</button>
              <span v-else class="enabled-pill">已开启保护模式</span>
            </div>
          </div>
          <div class="status-card">
            <span class="status-label">今日剩余</span>
            <strong>{{ remainingText }}</strong>
            <div class="progress-track" aria-hidden="true">
              <div class="progress-bar" :style="{ width: progressWidth }"></div>
            </div>
            <p>今日已使用 {{ usedText }}</p>
          </div>
        </section>

        <section class="feature-grid">
          <div class="feature-card">
            <span class="feature-icon">2h</span>
            <h2>每日两小时</h2>
            <p>每天按自然日重新计时，超时后自动进入全站锁定提醒。</p>
          </div>
          <div class="feature-card">
            <span class="feature-icon">守护</span>
            <h2>设备守护生效</h2>
            <p>开启后会持续记录本站访问时长，刷新页面或重新打开网站后仍会延续今日守护状态。</p>
          </div>
          <div class="feature-card">
            <span class="feature-icon">密码</span>
            <h2>关闭需要密码</h2>
            <p>开启时设置关闭密码，避免孩子自行关闭保护模式。</p>
          </div>
        </section>

        <section class="setting-card" ref="settingCard">
          <div class="setting-header">
            <p class="eyebrow">保护设置</p>
            <h2>{{ status.enabled ? '关闭青少年保护' : '开启青少年保护' }}</h2>
            <p v-if="status.enabled">保护模式已生效。如需关闭，请输入开启时设置的关闭密码。</p>
            <p v-else>请设置一个关闭密码。开启后，今日访问时间会从现在开始记录。</p>
          </div>

          <div v-if="message.text" :class="['message', message.type]" role="status">
            {{ message.text }}
          </div>

          <div v-if="!status.enabled" class="form-panel">
            <label class="field-group" for="youth-password">
              <span>关闭密码</span>
              <input
                id="youth-password"
                ref="passwordInput"
                v-model="password"
                type="password"
                autocomplete="new-password"
                placeholder="请设置 6 位以上关闭密码"
              />
            </label>
            <label class="field-group" for="youth-confirm-password">
              <span>确认关闭密码</span>
              <input
                id="youth-confirm-password"
                v-model="confirmPassword"
                type="password"
                autocomplete="new-password"
                placeholder="请再次输入关闭密码"
              />
            </label>
            <button class="primary-btn full" :disabled="submitting" @click="handleEnable">
              {{ submitting ? '正在开启...' : '确认开启青少年保护' }}
            </button>
          </div>

          <div v-else class="form-panel">
            <label class="field-group" for="disable-password">
              <span>关闭密码</span>
              <input
                id="disable-password"
                v-model="disablePassword"
                type="password"
                autocomplete="current-password"
                placeholder="请输入关闭密码"
              />
            </label>
            <button class="secondary-btn full" :disabled="submitting" @click="handleDisable">
              {{ submitting ? '正在校验...' : '关闭青少年保护' }}
            </button>
          </div>
        </section>

        <section class="content-container">
          <div class="content-text">
            <h2>一、功能说明</h2>
            <p>青少年保护功能用于帮助监护人引导未成年人合理安排上网时间。开启后，本站会记录每日访问时长，并在达到上限后进行全站锁定提醒。</p>
            <ul>
              <li>每日可访问时长为 2 小时</li>
              <li>超过时长后，页面会显示不可关闭的保护提示</li>
              <li>次日访问时，系统会自动重新计数</li>
            </ul>

            <h2>二、适用范围</h2>
            <p>本功能优先在当前设备上提供访问时长守护。若更换设备或清除网站数据，建议监护人重新检查并开启保护模式。</p>

            <h2>三、监护人建议</h2>
            <p>建议监护人结合家庭规则、设备系统自带的屏幕使用时间功能，以及日常陪伴沟通，共同帮助青少年建立健康的阅读和上网习惯。</p>
            <ul>
              <li>合理规划学习、休息和娱乐时间</li>
              <li>避免长时间连续注视屏幕</li>
              <li>鼓励未成年人在监护人陪同下使用网络服务</li>
            </ul>

            <h2>四、隐私与安全</h2>
            <p>保护密码仅用于校验关闭操作，系统不会展示原始密码。访问时长只用于判断当天是否达到保护上限。</p>

            <h2>五、联系我们</h2>
            <p>如对青少年保护功能有任何疑问或建议，请通过以下方式联系我们：</p>
            <ul>
              <li>公司名称：武汉天冉网络科技有限公司</li>
              <li>联系电话：13641239621</li>
              <li>电子邮箱：wudongjian@huashi.tv</li>
              <li>公司地址：湖北省武汉市洪山区雄楚大街452号保利蓝海郡G6栋1单元20层3室-2</li>
            </ul>

            <p class="update-time">最后更新时间：2026年6月23日</p>
          </div>
        </section>

        <AppFooter />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onBeforeUnmount, onMounted, reactive, ref } from 'vue';
import AppSidebar from '@/components/layout/Sidebar.vue';
import AppFooter from '@/components/layout/Footer.vue';
import {
  disableYouthProtection,
  enableYouthProtection,
  formatYouthProtectionDuration,
  getYouthProtectionStatus,
  setYouthProtectionLastActiveAt,
  settleYouthProtectionUsage
} from '@/utils/youthProtection';

export default {
  name: 'YouthProtectionPage',
  components: {
    AppSidebar,
    AppFooter
  },
  setup() {
    const password = ref('');
    const confirmPassword = ref('');
    const disablePassword = ref('');
    const submitting = ref(false);
    const passwordInput = ref(null);
    const settingCard = ref(null);
    const status = reactive(getYouthProtectionStatus());
    const message = reactive({
      type: '',
      text: ''
    });
    let statusTimer = null;

    const refreshStatus = () => {
      Object.assign(status, settleYouthProtectionUsage());
    };

    const usedText = computed(() => formatYouthProtectionDuration(status.usedMs));
    const remainingText = computed(() => formatYouthProtectionDuration(status.remainingMs));
    const progressWidth = computed(() => {
      const progress = status.limitMs ? (status.usedMs / status.limitMs) * 100 : 0;
      return `${Math.min(100, Math.max(0, progress))}%`;
    });

    const setMessage = (type, text) => {
      message.type = type;
      message.text = text;
    };

    const focusPassword = () => {
      settingCard.value?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => passwordInput.value?.focus(), 260);
    };

    const validateEnableForm = () => {
      if (password.value.length < 6) {
        setMessage('error', '请设置至少 6 位关闭密码。');
        return false;
      }

      if (password.value !== confirmPassword.value) {
        setMessage('error', '两次输入的关闭密码不一致，请重新确认。');
        return false;
      }

      return true;
    };

    const handleEnable = async () => {
      if (!validateEnableForm()) {
        return;
      }

      submitting.value = true;

      try {
        await enableYouthProtection(password.value);
        setYouthProtectionLastActiveAt();
        password.value = '';
        confirmPassword.value = '';
        refreshStatus();
        setMessage('success', '青少年保护已开启。今日访问时间将从现在开始记录。');
      } catch {
        setMessage('error', '开启失败，请稍后重试。');
      } finally {
        submitting.value = false;
      }
    };

    const handleDisable = async () => {
      if (!disablePassword.value) {
        setMessage('error', '请输入关闭密码。');
        return;
      }

      submitting.value = true;

      try {
        const disabled = await disableYouthProtection(disablePassword.value);

        if (!disabled) {
          setMessage('error', '关闭密码不正确，保护模式仍保持开启。');
          return;
        }

        disablePassword.value = '';
        refreshStatus();
        setMessage('success', '青少年保护已关闭。');
      } catch {
        setMessage('error', '关闭失败，请稍后重试。');
      } finally {
        submitting.value = false;
      }
    };

    onMounted(() => {
      document.title = '青少年保护 - 武汉天冉网络科技有限公司';
      refreshStatus();
      statusTimer = setInterval(refreshStatus, 1000);
    });

    onBeforeUnmount(() => {
      if (statusTimer) {
        clearInterval(statusTimer);
        statusTimer = null;
      }
    });

    return {
      password,
      confirmPassword,
      disablePassword,
      submitting,
      passwordInput,
      settingCard,
      status,
      message,
      usedText,
      remainingText,
      progressWidth,
      focusPassword,
      handleEnable,
      handleDisable
    };
  }
};
</script>

<style scoped>
.page-container {
  display: flex;
  min-height: 100vh;
  background: #f5f6fa;
}

.main-content {
  flex: 1;
  margin-left: 200px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.youth-page {
  width: 100%;
  padding: 40px 20px 0;
}

.hero-card,
.feature-grid,
.setting-card,
.content-container {
  max-width: 1040px;
  margin: 0 auto;
}

.hero-card {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(280px, 0.8fr);
  gap: 28px;
  align-items: stretch;
  padding: 38px;
  border: 1px solid rgba(54, 95, 75, 0.16);
  border-radius: 32px;
  background:
    radial-gradient(circle at top right, rgba(92, 150, 111, 0.18), transparent 38%),
    linear-gradient(135deg, #fffaf0 0%, #f3fbf5 100%);
  box-shadow: 0 22px 60px rgba(28, 47, 39, 0.1);
}

.eyebrow {
  margin-bottom: 10px;
  color: #5f8069;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.hero-copy h1 {
  margin-bottom: 16px;
  color: #1f3328;
  font-size: clamp(34px, 6vw, 56px);
  line-height: 1.08;
  letter-spacing: -0.04em;
}

.hero-desc {
  max-width: 660px;
  margin-bottom: 26px;
  color: #53675a;
  font-size: 17px;
  line-height: 1.8;
}

.hero-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.primary-btn,
.secondary-btn {
  min-height: 46px;
  padding: 0 22px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.18s ease, background-color 0.18s ease, border-color 0.18s ease;
}

.primary-btn {
  background: #2f6f55;
  color: #fff;
}

.secondary-btn {
  background: #fff;
  color: #2f6f55;
  border-color: rgba(47, 111, 85, 0.28);
}

.primary-btn:hover,
.secondary-btn:hover {
  transform: translateY(-1px);
}

.primary-btn:focus-visible,
.secondary-btn:focus-visible,
.field-group input:focus-visible {
  outline: 3px solid rgba(47, 111, 85, 0.28);
  outline-offset: 2px;
}

.primary-btn:active,
.secondary-btn:active {
  transform: translateY(0);
}

.primary-btn:disabled,
.secondary-btn:disabled {
  cursor: not-allowed;
  opacity: 0.68;
}

.full {
  width: 100%;
}

.enabled-pill {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  padding: 0 18px;
  border-radius: 999px;
  background: rgba(47, 111, 85, 0.12);
  color: #2f6f55;
  font-weight: 700;
}

.status-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 26px;
  border: 1px solid rgba(47, 111, 85, 0.16);
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.76);
}

.status-label {
  margin-bottom: 8px;
  color: #708174;
  font-size: 14px;
}

.status-card strong {
  margin-bottom: 18px;
  color: #1f3328;
  font-size: 32px;
}

.progress-track {
  height: 10px;
  overflow: hidden;
  border-radius: 999px;
  background: #e0eadf;
}

.progress-bar {
  height: 100%;
  border-radius: inherit;
  background: #2f6f55;
  transition: width 0.3s ease;
}

.status-card p {
  margin-top: 14px;
  color: #65776b;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  margin-top: 22px;
}

.feature-card,
.setting-card,
.content-container {
  border: 1px solid rgba(39, 69, 52, 0.1);
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 14px 36px rgba(28, 47, 39, 0.06);
}

.feature-card {
  padding: 24px;
}

.feature-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 46px;
  height: 38px;
  margin-bottom: 16px;
  padding: 0 10px;
  border-radius: 14px;
  background: #edf6ef;
  color: #2f6f55;
  font-size: 13px;
  font-weight: 800;
}

.feature-card h2 {
  margin-bottom: 10px;
  color: #23372c;
  font-size: 20px;
}

.feature-card p,
.setting-header p {
  color: #65766b;
  line-height: 1.7;
}

.setting-card,
.content-container {
  margin-top: 22px;
  padding: 30px;
}

.setting-header {
  margin-bottom: 22px;
}

.setting-header h2 {
  margin-bottom: 10px;
  color: #23372c;
  font-size: 26px;
}

.message {
  margin-bottom: 18px;
  padding: 13px 15px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.6;
}

.message.success {
  background: #e7f6ec;
  color: #276348;
}

.message.error {
  background: #fff0ee;
  color: #9b3b2f;
}

.form-panel {
  display: grid;
  gap: 16px;
  max-width: 560px;
}

.field-group {
  display: grid;
  gap: 8px;
  color: #34463a;
  font-weight: 700;
}

.field-group input {
  min-height: 48px;
  padding: 0 16px;
  border: 1px solid #d9e2dc;
  border-radius: 16px;
  color: #23372c;
  font-size: 15px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.field-group input:focus {
  border-color: #2f6f55;
  box-shadow: 0 0 0 4px rgba(47, 111, 85, 0.08);
}

.content-container {
  margin-bottom: 40px;
}

.content-text {
  line-height: 1.8;
  color: #444;
  font-size: 16px;
}

.content-text h2 {
  font-size: 22px;
  margin: 25px 0 15px;
  color: #333;
}

.content-text p {
  margin-bottom: 15px;
}

.content-text ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.content-text li {
  margin-bottom: 8px;
}

.update-time {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  color: #999;
  font-size: 14px;
  text-align: center;
}

@media (max-width: 900px) {
  .hero-card,
  .feature-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }

  .youth-page {
    padding: 20px 15px 0;
  }

  .hero-card,
  .setting-card,
  .content-container {
    padding: 22px;
    border-radius: 22px;
  }
}
</style>
